import { login } from "@/api/user";
import { getToken, setToken, removeToken, getName, setName, removeName, getUserPhone, setUserPhone, removeUserPhone } from "@/utils/auth";
// import router, { resetRouter } from "@/router";

const state = {
    token: getToken(),
    name: getName(),
    userPhone: getUserPhone()
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_NAME: (state, name) => {
        state.name = name;
    },
    SET_USER_PHONE: (state, userPhone) => {
        state.userPhone = userPhone;
    }
};

const actions = {
    login({ commit }, userInfo) {
        const { username, password } = userInfo;
        return new Promise((resolve, reject) => {
            login({ username, password })
                .then((response) => {
                    const { data } = response;
                    if (data) {
                        let temp = data;
                        commit("SET_NAME", temp.username);
                        setName(temp.username);
                        commit("SET_TOKEN", temp.id);
                        setToken(temp.id);
                        commit("SET_USER_PHONE", temp.phone);
                        setUserPhone(temp.phone);
                    }
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    // 统一认证登录-个人
    authLoginPerson({ commit }) {
        return new Promise((resolve, reject) => {
            // 从 sessionStorage 获取 client-userInfo 并解析
            const clientUserInfoStr = sessionStorage.getItem("client-userInfo");
            if (!clientUserInfoStr) {
                reject(new Error("client-userInfo 不存在"));
                return;
            }
            let clientUserInfo = null;
            try {
                clientUserInfo = JSON.parse(clientUserInfoStr);
            } catch (e) {
                console.error("解析 client-userInfo 失败:", e);
                reject(e);
                return;
            }

            const username = clientUserInfo.name || "";
            const token = clientUserInfo.uid || "";
            const phone = clientUserInfo.phone || "";

            commit("SET_NAME", username);
            setName(username);
            commit("SET_TOKEN", token);
            setToken(token);
            commit("SET_USER_PHONE", phone);
            setUserPhone(phone);
            console.log("authLoginPerson", { id: token, name: username, phone });
            resolve({ id: token, name: username, phone });
        });
    },
    // 统一认证登录-企业
    authLoginCompany({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            const authorization = sessionStorage.getItem("Authorization");
                    // 从 sessionStorage 获取 client-userInfo 并解析
                    const clientUserInfoStr = sessionStorage.getItem("client-userInfo");
                    let clientUserInfo = null;
                    if (clientUserInfoStr) {
                        try {
                            clientUserInfo = JSON.parse(clientUserInfoStr);
                        } catch (e) {
                            console.error("解析 client-userInfo 失败:", e);
                        }
                    }
                    
                    // 使用 sessionStorage 中的值
                    const username = clientUserInfo?.cn || "";
                    const token = authorization || "";
                    const phone = clientUserInfo?.idCardNumber || "";
                    
                    commit("SET_NAME", username);
                    setName(username);
                    commit("SET_TOKEN", token);
                    setToken(token);
                    commit("SET_USER_PHONE", phone);
                    setUserPhone(phone);
                    resolve({ id: token, company: username, comUscc: phone });
                
        });
    },
    resetToken({ commit }) {
        return new Promise((resolve) => {
            commit("SET_TOKEN", "");
            commit("SET_NAME", "");
            commit("SET_USER_PHONE", "");
            removeToken();
            removeName();
            removeUserPhone();
            sessionStorage.removeItem("client-userInfo");
            sessionStorage.removeItem("accessToken");
            sessionStorage.removeItem("authType");
            sessionStorage.removeItem("Authorization");
            localStorage.clear();
            sessionStorage.clear();
            resolve();
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
